export default __webpack_public_path__ + "a8fb00152615222235897b8a3fd8b7ea.png";